module.exports = __webpack_public_path__ + "static/plugins-fd4d15b6c1580b7b1ac974bb16b43dee.mp4";